import React, { createContext, useContext, useEffect, ReactNode } from 'react';
import { useApiCartHook, UseApiCartReturn } from './useApiCart';
import { useAuth } from './useAuth';

const ApiCartContext = createContext<UseApiCartReturn | undefined>(undefined);

interface ApiCartProviderProps {
  children: ReactNode;
}

export const ApiCartProvider: React.FC<ApiCartProviderProps> = ({ children }) => {
  const apiCart = useApiCartHook();
  const { user } = useAuth();

  // Load cart when user is authenticated
  useEffect(() => {
    if (user) {
      apiCart.loadCart();
    }
  }, [user, apiCart.loadCart]);

  return (
    <ApiCartContext.Provider value={apiCart}>
      {children}
    </ApiCartContext.Provider>
  );
};

export const useApiCart = (): UseApiCartReturn => {
  const context = useContext(ApiCartContext);
  if (context === undefined) {
    throw new Error('useApiCart must be used within an ApiCartProvider');
  }
  return context;
};